import { CirclePlusIcon } from 'lucide-react';

import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  HelperText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@/_components';
import { stopPropagate } from '@/_shared';

import { CreateEmail } from './create';
import { UpdateEmailItem } from './update-email-item';
import type { EditProps } from './use-edit';
import { useEdit } from './use-edit';

import { ActionButton } from '../../../actions';
import { ActionButtonContainer, FormLayout } from '../../../layout';

export function EditEmails(props: EditProps) {
  const { open, form, isLoading, createProps, onClose, onSubmit, onAdd, handleUpdateEmailItem } = useEdit(props);

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableBackdropClosing
      disableInternalClosing={form.formState.isSubmitting || isLoading}
    >
      <Form {...form}>
        {({ handleSubmit }) => (
          <form onSubmit={stopPropagate(handleSubmit(onSubmit))}>
            <ModalHeader>Edit Emails</ModalHeader>
            <ModalBody>
              <FormLayout>
                <CreateEmail {...createProps}>
                  <ActionButtonContainer>
                    <ActionButton title="Add new Email" icon={CirclePlusIcon} onClick={onAdd} />
                  </ActionButtonContainer>
                </CreateEmail>

                <FormField
                  control={form.control}
                  name="emails"
                  render={({ field }) => (
                    <>
                      {field?.value?.map((item, i) => {
                        return (
                          <FormField
                            control={form.control}
                            key={item.id}
                            name={`emails.${i}`}
                            render={() => (
                              <FormItem className="col-span-12" key={item.id}>
                                <FormControl>
                                  <UpdateEmailItem value={item} onChange={handleUpdateEmailItem} />
                                </FormControl>
                                <FormMessage className="-mt-8" id="email" />
                              </FormItem>
                            )}
                          />
                        );
                      })}
                      {form.formState.errors.emails?.message && (
                        <HelperText className={'text-error col-span-12 -mt-4 text-xs'}>
                          {form.formState.errors.emails?.message}
                        </HelperText>
                      )}
                    </>
                  )}
                />
              </FormLayout>
            </ModalBody>
            <ModalFooter className="mt-6">
              <Button
                modal
                type="submit"
                disabled={!(form.formState.isDirty || createProps.form.formState.isDirty)}
                showLoader={form.formState.isSubmitting || isLoading}
              >
                Done
              </Button>
            </ModalFooter>
          </form>
        )}
      </Form>
    </Modal>
  );
}
